interface LoadJsonResponse {
  BASE_URL: string
  CLIENT_ID: string
  GRANT_TYPE: string
  KEY_CLOACK: string
  GCLOUD_CLIENT_ID: string
  FACEBOOK_APP_ID: string
  APPLE_CLIENT_ID: string
  APPLE_CLIENT_ID_LEXUS: string
  APPLE_REDIRECT_URI: string
  APPLE_REDIRECT_URI_LEXUS: string
  SOCIAL_LOGIN_GOOGLE_ENABLED: string
  SOCIAL_LOGIN_FACEBOOK_ENABLED: string
  SOCIAL_LOGIN_APPLE_ENABLED: string
  LEXUS_DOMAIN: string
  URL_LEXUS: string
  TOYOTA_DOMAIN: string
  BRAND_TOYOTA: string
  BRAND_LEXUS: string
  APP_ID: string
  DISMISSION_DATE: string
}

let cachedConstants: LoadJsonResponse | null = null;
let pendingRequest: Promise<LoadJsonResponse> | null = null;

async function getNativeFetch(url: string) {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Fetch failed: ${response.statusText}`);
  return response.json();
}

export const loadConstants = async (): Promise<LoadJsonResponse> => {
  if (cachedConstants) return cachedConstants;
  if (pendingRequest) return pendingRequest;

  pendingRequest = (async () => {
    try {
      const publicApi = (await getNativeFetch(
        `${process.env.PUBLIC_URL}/api/api.json`
      )) as LoadJsonResponse;

      const bffResponse = await fetch(`${publicApi.BASE_URL}/${publicApi.APP_ID}/config/constants`);
      if (!bffResponse.ok) throw new Error("BFF error");
      const bffConfig = await bffResponse.json();

      cachedConstants = {
        BASE_URL: publicApi.BASE_URL,
        GRANT_TYPE: publicApi.GRANT_TYPE,
        APPLE_REDIRECT_URI: publicApi.APPLE_REDIRECT_URI,
        APPLE_REDIRECT_URI_LEXUS: publicApi.APPLE_REDIRECT_URI_LEXUS,
        SOCIAL_LOGIN_GOOGLE_ENABLED: publicApi.SOCIAL_LOGIN_GOOGLE_ENABLED,
        SOCIAL_LOGIN_FACEBOOK_ENABLED: publicApi.SOCIAL_LOGIN_FACEBOOK_ENABLED,
        SOCIAL_LOGIN_APPLE_ENABLED: publicApi.SOCIAL_LOGIN_APPLE_ENABLED,
        LEXUS_DOMAIN: publicApi.LEXUS_DOMAIN,
        TOYOTA_DOMAIN: publicApi.TOYOTA_DOMAIN,
        APP_ID: publicApi.APP_ID,
        BRAND_TOYOTA: publicApi.BRAND_TOYOTA,
        BRAND_LEXUS: publicApi.BRAND_LEXUS,
        URL_LEXUS: publicApi.URL_LEXUS,
        CLIENT_ID: bffConfig.CLIENT_ID,
        KEY_CLOACK: bffConfig.KEY_CLOACK,
        GCLOUD_CLIENT_ID: bffConfig.GCLOUD_CLIENT_ID,
        FACEBOOK_APP_ID: bffConfig.FACEBOOK_APP_ID,
        APPLE_CLIENT_ID: bffConfig.APPLE_CLIENT_ID,
        APPLE_CLIENT_ID_LEXUS: bffConfig.APPLE_CLIENT_ID_LEXUS,
        DISMISSION_DATE: bffConfig.DISMISSION_DATE,
      };

      return cachedConstants;
    } finally {
      pendingRequest = null;
    }
  })();

  return pendingRequest;
};

export const parseDismissionDate = (dismissionDate?: string): Date | null => {
  if (!dismissionDate) return null;

  const isoDateMatch = dismissionDate.match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
  const italianDateMatch = dismissionDate.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  const dateParts = isoDateMatch || italianDateMatch;

  if (!dateParts) return null;

  const [, firstPart, secondPart, thirdPart] = dateParts;
  const year = Number(isoDateMatch ? firstPart : thirdPart);
  const month = Number(secondPart);
  const day = Number(isoDateMatch ? thirdPart : firstPart);
  const parsedDismissionDate = new Date(year, month - 1, day);

  return parsedDismissionDate.getFullYear() === year &&
    parsedDismissionDate.getMonth() === month - 1 &&
    parsedDismissionDate.getDate() === day
    ? parsedDismissionDate
    : null;
};

export const isDismissionDateReached = (dismissionDate?: string): boolean => {
  const parsedDismissionDate = parseDismissionDate(dismissionDate);

  return parsedDismissionDate !== null && new Date() >= parsedDismissionDate;
};
